/* AthleteSwap Hilfe — "War das hilfreich?"-Widget am Ende jedes Artikels.
   Port von components/hilfe/HilfeFeedback.tsx. Rein clientseitig, kein
   Versand irgendwohin (das Original schrieb ebenfalls nichts an einen
   Server, nur lokaler React-State). */
(function () {
  function init(root) {
    var knoepfe = root.querySelectorAll('[data-antwort]');
    var mail = root.getAttribute('data-mail') || 'info@athleteswap.com';
    knoepfe.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var antwort = btn.getAttribute('data-antwort');
        if (antwort === 'ja') {
          root.innerHTML = '<p class="as-hilfe-feedback-dank">Danke für dein Feedback.</p>';
        } else {
          root.innerHTML =
            '<p class="as-hilfe-feedback-dank">Danke für dein Feedback — schreib uns gern, was gefehlt hat: <a href="mailto:' +
            mail +
            '">' +
            mail +
            '</a></p>';
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-as-hilfe-feedback]:not([data-as-hilfe-feedback-init])').forEach(function (root) {
      root.setAttribute('data-as-hilfe-feedback-init', '');
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
